import React from 'react';

export function ScoreRevealPopup({ scoreRevealMessage, creditScore, onDismiss }) {
  if (!scoreRevealMessage) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50" data-testid="score-reveal-popup">
      <div className="bg-ink-800 rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden animate-in zoom-in-95 duration-300">
        <div className="p-1 text-center text-foreground text-[10px] font-bold uppercase tracking-widest" style={{ backgroundColor: scoreRevealMessage.bankColor }}>
          {scoreRevealMessage.bankName}
        </div>
        <div className="p-6 text-center">
          <img
            src={scoreRevealMessage.advisorPortrait}
            alt={scoreRevealMessage.advisorName}
            className="w-20 h-24 rounded-xl object-cover object-top mx-auto border-3 mb-3"
            style={{ borderWidth: '3px', borderColor: scoreRevealMessage.bankColor }}
          />
          <p className="text-sm font-bold text-slate-200 mb-0.5">{scoreRevealMessage.advisorName}</p>
          <p className="text-[10px] text-slate-500 mb-4">{scoreRevealMessage.bankName}</p>

          <p className="text-sm text-slate-400 italic leading-relaxed mb-5">
            "{scoreRevealMessage.message}"
          </p>

          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-xl border-2 mb-4" style={{ borderColor: creditScore?.color }}>
            <span className="text-4xl font-black" style={{ color: creditScore?.color }}>{scoreRevealMessage.grade}</span>
            <div className="text-left">
              <p className="text-sm font-bold" style={{ color: creditScore?.color }}>{creditScore?.label}</p>
              <p className="text-xs text-slate-500">Score : {scoreRevealMessage.score}/100</p>
              {creditScore?.rateBonus !== 0 && (
                <p className={`text-[10px] font-medium ${creditScore?.rateBonus < 0 ? 'text-money' : 'text-danger'}`}>
                  {creditScore?.rateBonus < 0 ? `${(creditScore.rateBonus * 100).toFixed(1)}% sur les taux` : `+${(creditScore.rateBonus * 100).toFixed(1)}% sur les taux`}
                </p>
              )}
            </div>
          </div>

          <p className="text-[10px] text-slate-500 mb-4">
            Votre score est recalculé chaque mois en fonction de votre santé financière, votre réputation, votre flotte et votre historique de remboursement.
          </p>

          <button
            onClick={onDismiss}
            className="w-full py-2.5 rounded-lg text-sm font-bold text-foreground transition-colors hover:opacity-90"
            style={{ backgroundColor: scoreRevealMessage.bankColor }}
            data-testid="dismiss-score-reveal-btn"
          >
            Compris
          </button>
        </div>
      </div>
    </div>
  );
}
